import "@mdi/font/css/materialdesignicons.css";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { VDateInput } from "vuetify/labs/VDateInput";
import { VNumberInput } from "vuetify/labs/VNumberInput";
import { VTimePicker } from "vuetify/labs/VTimePicker";
import "vuetify/styles";
import { createVuetify } from "vuetify";

export default createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi },
  },
  components: {
    VDateInput,
    VTimePicker,
    VNumberInput,
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#4F8EF7",
          secondary: "#EEFBFF",
          tertiary: "#F3EEFF",
          background: "#EEFBFF",

          textPrimary: "#0D1B2A",

          toolbar: "#FFFFFF",
          navbar: "#FFFFFF",
          textField: "#000000",
          submitButton: "#D9F5F0",
          cardColor: "#F1F1F1",

          greyVariant1: "#808080",
          greyVariant2: "#8c8f9d",
          greyVariant3: "#878a99",
          greyVariant4: "#495057",

          blueVariant1: "#def1fb",

          greenVariant1: "#d9f5f0",
          greenVariant2: "#00bd9d",

          primaryVariant1: "#DC143B",

          BlueColorVariant1: "#0a6d9c",
          BlueColorVariant2: "#0a6d91",
          BlueColorVariant3: "#2cb2f1",

          redVariant1: "#FECFD8",

          DarkBlue: "#050a30",
          NavyBlue: "#000c66",
          Blue2: "#0000ff",
          MidNightBlue: "#145da0",
          greenText: "#116530",
          unReadNotificationColor: "#B3E5FC",
          readNotificationColor: "#E1F5FE",
          textPrimary: "#000000",
          textSecondary: "#4A4A4A",
        },
      },

      dark: {
        dark: true,
        colors: {
          primary: "#00F2FE",
          secondary: "#0A213E",
          background: "#020610",
          tertiary: "#0D3D5C",
          surface: "#0A213E",

          toolbar: "#0A213E",
          navbar: "#020610",
          textField: "#FFFFFF",
          submitButton: "#D9F5F0",
          cardColor: "#000000",

          textPrimary: "#FFFFFF",
          textSecondary: "#B0B0B0",

          greyVariant1: "#7F7F7F",
          greyVariant2: "#737062",
          greyVariant3: "#787566",
          greyVariant4: "#B6AFA8",

          blueVariant1: "#210E04",
          greenVariant1: "#260A0F",
          greenVariant2: "#FF4262",

          primaryVariant1: "#23EBC4",

          BlueColorVariant1: "#F59263",
          BlueColorVariant2: "#F5926E",
          BlueColorVariant3: "#D34D0E",

          redVariant1: "#013027",

          DarkBlue: "#FAF5CF",
          NavyBlue: "#FFF399",
          Blue2: "#FFFF00",
          MidNightBlue: "#EBA25F",
          greenText: "#EE9ACF",
          unReadNotificationColor: "#4C1A03",
          readNotificationColor: "#1E0A01",

          textPrimary: "#FFFFFF",
          textSecondary: "#B0B0B0",
        },
      },
    },
  },
});
